import React from "react";
import TitleStripe from "../TitleStripe";
import { BiDollar } from "react-icons/bi";
import { formatToReal } from "../../../utils/utils";

export default function FaturamentoReal({
  data,
  periodLabel = "Últimos 3 meses",
  className = "",
}) {
  if (data?.indicador == null) {
    return (
      <div>
        <TitleStripe>Faturamento Real</TitleStripe>

        <div
          className={`w-full rounded-md border border-gray-200 p-5 mt-4 ${className}`}
        >
          <div className="flex items-center gap-3">
            <BiDollar className="w-7 h-7 text-gray-300" />
            <span className="text-gray-500 text-base">
              Faturamento não disponível
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={className}>
      <TitleStripe>Faturamento Real</TitleStripe>
      <div className="mt-4 rounded-2xl border border-emerald-200 bg-gradient-to-br from-emerald-50 to-white p-5 shadow-sm">
        <div className="flex flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="bg-emerald-100 rounded-full p-3 flex-shrink-0 flex items-center justify-center">
              <BiDollar className="w-7 h-7 text-emerald-600" />
            </div>
            <div>
              <p className="text-[15px] uppercase tracking-wide text-emerald-700 font-semibold">
                Faturamento Real da empresa
              </p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-4xl font-extrabold text-emerald-900 tabular-nums">
              {Number(data.indicador) > 0 &&
                formatToReal((+data.indicador / 12) * 1.1)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
